
  
  function sum1(a: number, b: number): number {
    return a + b;
  }
  console.log( ">>>>>>>>>>>>> :: " +  sum1(10, 30) ); 

  

  function multiply(a: number, ccc: number): number {
    return a + ccc;
  }
  console.log( ">>>>>>>>>>>>> :: " +  multiply(10, 30) ); 
 